export default {
  namespaced: true,
  state: {
    popupFiltersVisible: false,
    currentPage: '/',
    currentTab: 'home',
    currentSubTab: '', // Tab actual dentro de la vista secundaria
    tabToGo: null, // Tab que se puede especificar antes de navegar
    isReturning: false, // Estado para manejar que volvemos atras con el boton volver
  },
  mutations: {
    SET_POPUP_FILTERS_VISIBLE(state, value) {
      state.popupFiltersVisible = value;
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value;
    },
    SET_CURRENT_TAB(state, value) {
      state.currentTab = value;
    },
    SET_CURRENT_SUBTAB(state, value) {
      state.currentSubTab = value;
    },
    SET_TAB_TO_GO(state, value) {
      state.tabToGo = value;
    },
    SET_IS_RETURNING(state, value) {
      state.isReturning = value;
    },
  },
  actions: {
    setPopupFiltersVisible({ commit }, value) {
      commit('SET_POPUP_FILTERS_VISIBLE', value);
    },
    setTabToGo({ commit }, value) {
      commit('SET_TAB_TO_GO', value);
    },
    setCurrentPage({ commit }, value) {
      commit('SET_CURRENT_PAGE', value);
    },
    setCurrentTab({ commit }, value) {
      commit('SET_CURRENT_TAB', value);
    },
    setCurrentSubTab({ commit }, value) {
      commit('SET_CURRENT_SUBTAB', value);
    },
    setIsReturning({ commit }, value) {
      commit('SET_IS_RETURNING', value);
    },
  },
};